import GraphicPackingTableHelper from './graphic-packing-table-helper';

const GraphicPackingHelpers = {
    TableMain: GraphicPackingTableHelper,
};

export default GraphicPackingHelpers;